import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { contentApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'content-remove-material';

export const removeContentMaterial = ({ id, managerId }: contentApiTypes.RemoveMaterialParams) => {
  return axios.delete(`/content/materials/${id}`, {
    params: managerId ? { managerId } : undefined,
  });
};

type RemoveContentMaterialOptions = {
  pageId?: string;
  config?: MutationConfig<typeof removeContentMaterial>;
};

export const useRemoveContentMaterial = ({
  pageId,
  config = {},
}: RemoveContentMaterialOptions = {}) => {
  const { onSuccess, onMutate, onError, ...restConfig } = config;

  return useMutation({
    ...restConfig,
    mutationFn: removeContentMaterial,
    onMutate: (variables) => {
      toasts.loadingToast.loading(TOAST_ID, 'Удаление...');
      return onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      toasts.loadingToast.success(TOAST_ID, 'Материал удалён');
      if (pageId) {
        queryClient.invalidateQueries(['content-materials', pageId]);
      }
      onSuccess?.(data, variables, context);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      onError?.(error, variables, context);
    },
  });
};
